import type { ReactNode } from "react";

const verticalTams = [
  { label: "Paralegal / LPO", value: "$36B" },
  { label: "KYC / AML", value: "$30-50B" },
  { label: "Accounting & audit", value: "$50-80B" },
  { label: "Legal transactional", value: "$20-25B" },
];

const tailwinds: ReactNode[] = [
  <><strong className="font-medium text-[var(--color-fg)]">EU AI Act (Aug 2026):</strong> raises the compliance bar. Small firms can&apos;t meet it alone.</>,
  <><strong className="font-medium text-[var(--color-fg)]">UK ABS framework:</strong> legal structure for non-lawyer ownership. A structural advantage.</>,
  <><strong className="font-medium text-[var(--color-fg)]">PE flooding professional services:</strong> consolidation accelerating, AI-native players just starting.</>,
];

export function V3MarketSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[28px] font-light tracking-tight mb-2 font-[family-name:var(--font-heading)]">
        $136-191B in directly addressable Autopilot Territory.
      </h2>
      <p className="text-[12px] text-[var(--color-fg-secondary)] font-light leading-relaxed mb-5">
        Sequoia&apos;s Autopilot Territory: work that is intelligence-heavy AND already outsourced. The three verticals COSX is building agents for.
      </p>

      <div className="grid grid-cols-[1.2fr_1fr] divide-x divide-[var(--color-border)]">
        {/* Left: Vertical TAMs (Autopilot Territory breakdown) */}
        <div className="pr-6">
          <div className="text-[11px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-3 pb-2 border-b border-[var(--color-border)]">
            Autopilot Territory · vertical TAM
          </div>
          <div className="space-y-2">
            {verticalTams.map((d, i) => (
              <div
                key={d.label}
                className="flex justify-between items-baseline text-[12px] pb-2"
                style={{ borderBottom: i < verticalTams.length - 1 ? "1px solid var(--color-border)" : "none" }}
              >
                <span className="text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)]">{d.label}</span>
                <span className="font-bold text-[var(--color-fg)]">{d.value}</span>
              </div>
            ))}
          </div>

          <div className="mt-5 pt-3 border-t border-dashed border-[var(--color-border)] flex items-baseline gap-3">
            <span className="text-[28px] font-light tracking-tight font-[family-name:var(--font-heading)]">$136-191B</span>
            <span className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">Addressable market</span>
          </div>

          <p className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] leading-relaxed mt-4 opacity-70">
            Mapped to three COSX verticals: Paralegal/LPO + Legal Transactional → Legal; KYC/AML → Fund Ops & Compliance; Accounting & Audit → Accounting.
          </p>
        </div>

        {/* Right: Tailwinds */}
        <div className="pl-6">
          <div className="text-[11px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-3 pb-2 border-b border-[var(--color-border)]">
            Tailwinds
          </div>
          <div className="space-y-3">
            {tailwinds.map((t, i) => (
              <div key={i} className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] shrink-0 mt-1.5" />
                <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] font-medium text-[var(--color-fg)]">
          The market is fragmented, underserved, and ripe for AI-native consolidation.
        </p>
      </div>
    </div>
  );
}
